module.exports = __webpack_public_path__ + "img/logo-white.37ac517a.svg";